import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: Theme.primaryMargin
    },
    backdrop: {
        backgroundColor: 'rgba(0,0,0,0.9)'
    },
    opaque: {
        backgroundColor: '#000'
    }
};

export default StyleSheet.create(baseStyles);
